import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { setOwner } from '../../../actions/SetOwnerAction';
import { ISetOwnerAction } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource, anyItemIsUnpublishedWorkbook, userCanManageAlerts } from './IEntityActionHelpers';

export const SetOwnerAction: IEntityAction<IContentInfo, ISetOwnerAction> = {
  name: EntityActionNames.SetOwner,
  translateName: Messages.changeOwner_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetOwnerAction, targetItems: IContentInfo[], state: AppState) => {
    if (anyItemIsUnpublishedWorkbook(targetItems)) {
      return false;
    }

    return !!(availableActions && availableActions.setOwner) || userCanManageAlerts(state, targetItems);
  },
  createReduxAction: (targetItems: IContentInfo[]) => setOwner(targetItems)
};
